import React, { useEffect, useState } from 'react';
import { ActivitiesManagementDialog } from '../../../../../../SharedComponents/ActivitiesManagementDialog/ActivitiesManagementDialog';
import { GetActivityById } from '../../../../../../Services';
import { Spinner } from '../../../../../../Components';
import { useKeyGenerator } from '../../../../../../Hooks/keyGenerator';
import { useVendorContext } from '../../../context/VendorContext';

const VendorActivityManagementDialog = ({
  open,
  parentTranslationPath,
  activeItemId,
  onClose,
  reload,
}) => {
  const { vendorDetails: vendor } = useVendorContext();
  const [isLoading, setIsLoading] = useState(false);
  const [key, refresh] = useKeyGenerator();
  const [activeItem, setActiveItem] = useState(null);

  const getActivityById = async () => {
    setIsLoading(true);
    const activity = await GetActivityById(activeItemId);
    if (activity.activityId) {
      setActiveItem(activity);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    if (activeItemId) {
      getActivityById();
    }
  }, [activeItemId]);
  if (isLoading) {
    return <Spinner isActive isAbsolute />;
  }
  return (
    <ActivitiesManagementDialog
      key={key}
      open={open}
      parentTranslationPath={parentTranslationPath}
      activeItem={activeItem}
      contactId={vendor?.contactId}
      isVendorActivity
      close={onClose}
      actionItemId={vendor?.contactId}
      onSave={() => {
        onClose();
        refresh();
        reload();
      }}
    />
  );
};
export default VendorActivityManagementDialog;
